<template>
    <div class="withdrawal-telegram-subscribe-button" @click="$emit('click')">
        <i class="icon i-svg-telegram"></i>
        <p>{{ $t('withdrawal.telegram-subscribe') }}</p>
    </div>
</template>

<script setup lang="ts">
defineEmits(['click']);
</script>

<style lang="scss">
.withdrawal-telegram-subscribe-button {
    margin: 28px 0 24px;
    border-radius: 18px;
    background-color: #E6F2FF;
    color: #007AFF;
    padding: 12px 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    gap: 12px;
    font-weight: 500;
    font-size: 14px;
    line-height: 120%;

    &.active-state {
        opacity: 0.8;
    }

    .i-svg-telegram {
        width: 24px;
        height: 24px;
        background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_11529_24162)'%3E%3Crect width='24' height='24' fill='%23039BE5'/%3E%3Cpath d='M4.63508 11.85C5.96225 11.1218 7.44373 10.514 8.82795 9.90311C11.2094 8.90253 13.6002 7.91928 16.0152 7.00389C16.4851 6.84792 17.3293 6.69539 17.4121 7.38902C17.3668 8.37085 17.1803 9.34693 17.0524 10.323C16.7278 12.4695 16.3525 14.6086 15.9866 16.7481C15.8606 17.4607 14.9644 17.8296 14.391 17.3736C13.0129 16.4463 11.6242 15.5281 10.2637 14.5793C9.81808 14.1282 10.2313 13.4805 10.6294 13.1583C11.7644 12.0441 12.9681 11.0974 14.0438 9.92559C14.334 9.22757 13.4766 9.81584 13.1938 9.99608C11.64 11.0627 10.1241 12.1945 8.48589 13.1319C7.64908 13.5908 6.67375 13.1987 5.83731 12.9426C5.08734 12.6333 3.98843 12.3216 4.63508 11.85Z' fill='white'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_11529_24162'%3E%3Crect width='24' height='24' rx='12' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
    }
}
</style>